var cibKeras = ["32 32", "<path d='M32 0h-32v32h32zM11.266 6.88l0.266 0.224v8.323l8.615-8.599h2.615l0.266 0.531-6.854 6.802 7.297 10.583-0.271 0.401h-2.583l-6.203-9.172-2.88 2.771v6.135l-0.25 0.266h-1.948l-0.266-0.266v-17.776l0.224-0.224z'/>"];

export { cibKeras };

